import React from 'react';
import propTypes from 'prop-types';
import { FormGroup, FormFeedback, Input, Label } from 'reactstrap';

import { makeId } from 'utils/selectors';

import HelpIcon from './HelpIcon';

/**
 * render a checkbox input
 * @param {object} props - props passed to the component
 * @returns {React.Component} - Checkbox canvas widget
 */
const Checkbox = ({
  fieldContract: { checkedValue, helpText, name, uncheckedValue },
  isReadonly,
  onChange,
  selectedValue,
  updateLocation,
  validationMessage
}) => (
  <FormGroup className="mr-0" check inline>
    <div className="d-flex align-items-top my-3">
      <Label check>
        <Input
          invalid={validationMessage}
          type="checkbox"
          checked={selectedValue === checkedValue}
          disabled={isReadonly}
          onChange={e => onChange(e.target.checked ? checkedValue : uncheckedValue)}
          data-test-id={makeId({ updateLocation })}
        />
        {name}
        <FormFeedback>{validationMessage}</FormFeedback>
      </Label>
      {helpText && <HelpIcon id={makeId({ updateLocation })} message={helpText} />}
    </div>
  </FormGroup>
);

Checkbox.propTypes = {
  fieldContract: propTypes.shape({
    checkedValue: propTypes.oneOfType([propTypes.bool, propTypes.string]),
    helpText: propTypes.string,
    name: propTypes.string,
    uncheckedValue: propTypes.oneOfType([propTypes.bool, propTypes.string])
  }).isRequired,
  isReadonly: propTypes.bool,
  onChange: propTypes.func.isRequired,
  selectedValue: propTypes.oneOfType([propTypes.bool, propTypes.string]).isRequired,
  updateLocation: propTypes.string.isRequired,
  validationMessage: propTypes.string
};

Checkbox.defaultProps = {
  isReadonly: false,
  validationMessage: undefined
};

export default Checkbox;
